export const TEST_ID = 'multiSelectDroneField';
